const _origin = process.env.NEXT_PUBLIC_API_BASE_URL ?? "http://localhost:9100";
const _prefix = process.env.NEXT_PUBLIC_BACKEND_PREFIX ?? "";
const BASE = `${_origin}${_prefix}`;

export type CallStatus =
  | "idle" | "listening" | "user_speaking" | "processing" | "assistant_speaking"
  | "dialing" | "ringing" | "answered" | "ended";

export interface NordWSCallbacks {
  onOpen: () => void;
  onTranscription: (text: string) => void;
  onDelta: (token: string) => void;
  onReply: (data: Record<string, unknown>) => void;
  onAudioChunk: (wav: ArrayBuffer) => void;
  onVadState: (speaking: boolean) => void;
  onTurnComplete: () => void;
  onStopPlayback: () => void;
  onError: (msg: string) => void;
  onClose: () => void;
}

export type AudioMode = "file" | "stream";

export class NordWebSocket {
  private ws: WebSocket;

  constructor(sessionId: string, callbacks: NordWSCallbacks, audioMode: AudioMode = "file", basePath = "/session") {
    const wsBase = BASE.replace(/^http/, "ws");
    this.ws = new WebSocket(`${wsBase}${basePath}/${sessionId}/ws?audio_mode=${audioMode}`);
    this.ws.binaryType = "arraybuffer";

    this.ws.onopen = () => callbacks.onOpen();

    this.ws.onmessage = (ev: MessageEvent) => {
      if (ev.data instanceof ArrayBuffer) {
        callbacks.onAudioChunk(ev.data);
        return;
      }
      const msg = JSON.parse(ev.data as string);
      switch (msg.type) {
        case "transcription":
          callbacks.onTranscription(msg.text);
          break;
        case "delta":
          callbacks.onDelta(msg.token);
          break;
        case "reply": {
          const { type: _type, ...rest } = msg;
          callbacks.onReply(rest);
          break;
        }
        case "vad_state":
          callbacks.onVadState(msg.speaking);
          break;
        case "turn_complete":
          callbacks.onTurnComplete();
          break;
        case "stop_playback":
          callbacks.onStopPlayback();
          break;
        case "error":
          callbacks.onError(msg.message);
          break;
      }
    };

    this.ws.onclose = () => callbacks.onClose();
    this.ws.onerror = () => callbacks.onError("语音连接失败");
  }

  sendAudio(pcm: ArrayBuffer): void {
    if (this.ws.readyState === WebSocket.OPEN) {
      this.ws.send(pcm);
    }
  }

  sendMessage(msg: Record<string, unknown>): void {
    if (this.ws.readyState === WebSocket.OPEN) {
      this.ws.send(JSON.stringify(msg));
    }
  }

  close(): void {
    this.ws.close();
  }
}
